<template>
    <div>
        <b-card
            v-if="item.associate_type === 'physical'"
            no-body
            class="shadow-sm mb-3"
        >
            <b-card-body>
                <physical-person-data
                    :data="item.associate_data"
                    :editable="true"
                />
                <b-button variant="danger" size="sm" @click="confirmDelete">
                    <i class="fas fa-trash-alt fa-fw"></i> Supprimer l'associé·e
                </b-button>
            </b-card-body>
        </b-card>

        <b-card
            v-if="item.associate_type === 'moral'"
            no-body
            class="shadow-sm mb-3"
        >
            <b-card-body>
                <moral-person-data :data="item.associate_data" />
                <b-button variant="danger" size="sm" @click="confirmDelete">
                    <i class="fas fa-trash-alt fa-fw"></i> Supprimer l'associé·e
                </b-button>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PhysicalPersonData from '../physicalPersons/PhysicalPersonData'
import MoralPersonData from '../moralPersons/MoralPersonData'

export default {
    name: 'Associate',

    components: {
        MoralPersonData,
        PhysicalPersonData,
    },

    props: {
        item: null,
    },

    methods: {
        confirmDelete() {
            this.$bvModal
                .msgBoxConfirm(
                    'Etes-vous sûr·e de vouloir supprimer cet·te associé·e ?',
                    {
                        title: "Suppression d'un·e associé·e",
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'OUI',
                        cancelTitle: 'NON',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then((value) => {
                    if (value) {
                        this.deleteAssociate()
                    }
                })
                .catch((err) => {
                    // An error occurred
                })
        },

        async deleteAssociate() {
            try {
                const response = await axios.delete(
                    `/associates/${this.item.id}`
                )
                this.$store.commit('legalVM/SET_CLIENT', response.data.data)
                this.$store.commit('legalVM/RESET_STATUS')
            } catch (error) {
                // handle error
                console.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
